"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiIconButton = void 0;
var typography_1 = require("../../../theme/global/typography");
var palette_1 = require("../../../theme/global/palette");
exports.MuiIconButton = {
    root: {
        flex: '0 0 auto',
        fontSize: typography_1.typography.pxToRem(24),
        padding: 11,
        borderRadius: '50%',
        overflow: 'visible',
        fill: palette_1.palette.grey[800],
        color: palette_1.palette.grey[800],
        '&:hover': {
            backgroundColor: palette_1.palette.grey[200],
            '@media (hover: none)': {
                backgroundColor: 'transparent',
            },
        },
        '&:active': {
            backgroundColor: palette_1.palette.grey[400],
        },
        '&$disabled': {
            backgroundColor: 'transparent',
            fill: palette_1.palette.grey[400],
            color: palette_1.palette.grey[400],
        },
    },
    /* Styles applied to the root element if `edge="start"`. */
    edgeStart: {
        marginLeft: -12,
        '$sizeSmall&': {
            marginLeft: -3,
        },
    },
    /* Styles applied to the root element if `edge="end"`. */
    edgeEnd: {
        marginRight: -12,
        '$sizeSmall&': {
            marginRight: -3,
        },
    },
    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
        fill: 'inherit',
        color: 'inherit',
    },
    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
        fill: palette_1.palette.primary.main,
        color: palette_1.palette.primary.main,
    },
    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
        fill: palette_1.palette.secondary.main,
        color: palette_1.palette.secondary.main,
    },
    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},
    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
        padding: 8,
        fontSize: typography_1.typography.pxToRem(16),
    },
    /* Styles applied to the children container element. */
    label: {
        width: '100%',
        display: 'flex',
        alignItems: 'inherit',
        justifyContent: 'inherit',
    },
};
